"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Values used to determine when layouts should update. If you make updates to
 * this file, you should also update `stylesheets/media.less` so CSS and JS
 * layouts stay in sync.
 */
var layoutConstants = {
  extraLarge: 1600,
  large: 1220,
  medium: 960,
  small: 770,
  extraSmall: 450
};
var _default = layoutConstants;
exports["default"] = _default;